module.exports = __webpack_public_path__ + "media/images/vegitable_option-c3fa959704c441ff9f02572a54e152fb.jpg";